import React from "react";
import "../styles/FunProjects.css";
import { FaGithub } from "react-icons/fa";
import StyleHive from "../images/FunProjects/style_hive.png";
import streamLit from "../images/FunProjects/streamlitApp.png";
import excelValid from "../images/FunProjects/excel-validator.png";
import crypto from "../images/FunProjects/crypto-news-app.png";
import videoSnipper from "../images/FunProjects/video-snipper.png";

const projects = [
  {
    title: "Style Hive",
    description: "E-commerce platform with Google Auth, Firebase integration, Redux state management, and styled-components.",
    technologies: ["React", "Firebase", "Redux", "Auth"],
    img: StyleHive,
    github: "https://github.com/srijansa/StyleHive",
    size: "large"
  },
  {
    title: "Diabetes ML & Streamlit App",
    description: "Machine Learning-powered diagnostics with EDA, batch & single input handling via Flask and Streamlit interface.",
    technologies: ["Python", "Streamlit", "Flask", "EDA"],
    img: streamLit,
    github: "https://github.com/srijansa/Diabetes-ML-Application"
  },
  {
    title: "Excel Validator",
    description: "Java-based desktop utility to validate complex Excel formats before DB ingestion—ideal for financial workflows.",
    technologies: ["Java", "Apache POI"],
    img: excelValid,
    github: "https://github.com/srijansa/Excel-Validator-JDBC"
  },
  {
    title: "Crypto News Tracker",
    description: "Live crypto updates with filterable feeds and intuitive UI design.",
    technologies: ["React", "API Integration"],
    img: crypto,
    github: "https://github.com/srijansa/NewsApp"
  },
  {
    title: "Video Snipper App",
    description: "Lightweight JavaFX video player with looping, screenshot, playback control, and custom themes.",
    technologies: ["Java", "JavaFX"],
    img: videoSnipper,
    github: "https://github.com/srijansa/Video-Snipper"
  }
];

const FunProjects = () => {
  return (
    <div className="fun-projects-container">
      <h2 className="fun-title">Fun Projects</h2>
      <div className="project-masonry">
        {projects.map((project, index) => (
          <div
            key={index}
            className={`project-masonry-card ${project.size === "large" ? "large" : "small"}`}
          >
            <img src={project.img} alt={project.title} className="project-img" />
            <div className="project-text">
              <p className="project-source">{project.technologies.join(" • ")}</p>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-desc">{project.description}</p>
              <div className="project-footer">
                <a href={project.github} target="_blank" rel="noopener noreferrer">
                  <FaGithub className="github-icon" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FunProjects;
